
import MyAccount from "./components/MyAccount";
import UnauthorizedCom from "./components/UnauthorizedCom";
import Maintenance from "./components/Maintenance";
import SavedCardList from "./components/SavedCardList";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

const pg_url = require("../pg_url");
const CryptoJS = require("crypto-js");
import Cookies from "js-cookie";
import VuePhoneNumberInput from "vue-phone-number-input";
import jwt_decode from "jwt-decode";
import BISC from "./components/BISC";
import EMIBankList from "./EMIBankList.vue";
import EMIDisplayBankList from "./EMIDisplayBankList.vue";
import InstallmentList from "./InstallmentList.vue";
import { base_url } from "../pg_url";
import spTransaction from "./mixins/spTransaction";
import spWallets from "./mixins/spWallets";
import spCards from "./mixins/spCards";
import spIBanking from "./mixins/spIBanking";
import spEmi from "./mixins/spEmi";
import spAuthCof from "./mixins/spAuthCof";
import spAuthLegacy from "./mixins/spAuthLegacy";
import spSavedCards from "./mixins/spSavedCards";
import spSessionTimer from "./mixins/spSessionTimer";
import spUi from "./mixins/spUi";

export default {
  name: "App",
  components: {
    MyAccount,
    UnauthorizedCom,
    Maintenance,
    SavedCardList,
    VuePhoneNumberInput,
    BISC,
    EMIBankList,
    EMIDisplayBankList,
    InstallmentList,
  },

  mixins: [
    spTransaction,
    spWallets,
    spCards,
    spIBanking,
    spEmi,
    spAuthCof,
    spAuthLegacy,
    spSavedCards,
    spSessionTimer,
    spUi,
  ],

  data: () => ({

    // Add new OTP login properties
    footer_div_show: true,
    showSignupForm: false,
    showLoginOTPForm: false,
    // First step on the LOGIN tab: enter mobile number and check existence.
    showMobileCheckForm: true,
    // Shown only after we know the number exists.
    showPinLoginForm: false,
    loginPin: "",
    // Reset-PIN (OTP verification then set new PIN) flow states.
    showResetPinOtpForm: false,
    showResetPinForm: false,
    resetPinOtp: "",
    newPin: "",
    newPinConfirm: "",
    loginOTP: ['', '', '', '', '', ''],
    resendTimer: 0,
    resendDisabled: false,
    resendTimerInterval: null,


    merchantConfigData: {}, // Initially empty object to store API response
    //EMI - RINTU (25-01-2024)
    minimum_emi_amount: 5000,
    isTransactionEMI: 0,
    disableCardTab: false,
    disableMbankingTab: false,
    disableIBankingTab: false,
    disableLoginTab: false,
    disableProfileTab: false,
    hiddenSlugs: [],
    selectedTenure: null,

    //BISC
    is_bisc_display: false,
    show_emi_button: true,
    banks: [],
    selectedBankInstallments: [],

    snackbar: false,
    color: "#0F9750",
    mode: "",
    timeout: 4000,
    popup_text: "",

    base_url: pg_url.base_url,
    image_base_url: pg_url.image_base_url,
    merchant_logo_image_base_url: pg_url.merchant_logo_image_base_url,
    cancel_base_url: pg_url.cancel_base_url,
    customer_api_base_url: pg_url.customer_api_base_url,

    merchant_logo: "",
    merchant_name: "",
    customer_name: "",

    bkash_img: require("./assets/logos/bkash_mobile.png"),
    //Bkash edu promotion
    advertisement_img: require("./assets/advertisement/bkash-education-promotion.jpg"),
    isEducation: false,
    advertisement_link: 'https://www.bkash.com/',

    hasNumSaved: false,
    fastPayStatus: false,
    active_tab: "",
    card: false,
    popup_dialog: false,
    colWidth: 12,
    is_emi_visible: false,
    is_emi_active: 0,
    checkbox: false,
    toc_checkbox: false,
    selectedTab: null,
    active_bar: null,

    loading_tab: false,
    loading_dialog: false,

    emi_display_tab: false,
    emi_tab: false,

    card_tab: false,
    saved_card_tab1: false,
    mobile_banking: false,
    i_banking: false,
    user_account: false,
    cardSkeletonLoader: true,
    selectedBankId: null,

    attrs: {},

    login_div: true,
    myaccount: false,
    no_login: true,
    forgot_password_modal: false,
    forgot_password_otp_modal: false,

    active_account_modal: false,
    active_account_mobile: "",
    active_acc_otp: false,
    active_account_otp_input: "",

    signup_div: false,
    value: String,
    isFormValid: false,
    isFormValid2: false,
    isFormValidNew: false,
    other_cards_display: false,
    hideCard_div: true,
    hidecardmenu: true,
    hideshowpaynow: true,
    myPass: "",
    new_password_val: "",
    confirmed_new_password_val: "",

    visaActive: true,
    visaDeactive: false,
    masterCardActive: true,
    masterCardDeactive: false,
    amexActive: true,
    amexDeactive: false,
    unionpayActive: true,
    unionpayDeactive: false,
    dinersActive: true,
    dinersDeactive: false,

    sp_orderid: "",
    sp_amount: "",
    sp_amount_display: "",

    sp_currency: "",
    sp_token: "",

    sp_return_url: "",
    sp_cancel_url: "",

    isMainDiv: false,
    isUnauthorized: false,
    isMaintenanceMode: false,
    emi_options: "",
    saved_bkash: "",

    editedItem: {
      card_number: "",
      mm: "",
      yyyy: "",
      mm_yy: "",
      cvc_cvv: "",
      card_holder_name: "",
      emi: "",
    },

    loginItem: {
      login_mobile_number: "",
      login_password: "",
    },

    signup_items: {
      fullname: "",
      mobile_number: "",
      email_address: "",
      password: "",
    },

    others: {
      mobile_number: "",
    },

    mobileNumberRule: [
      (v) => !!v || "Mobile number is required",
      (v) => /^-?\d*$/.test(v) || "Mobile number can only be numbers",
    ],

    mobile_num_sign_up: [
      (v) => !!v || "Mobile number is required",
      (v) => /^-?\d*$/.test(v) || "Mobile number can only be numbers",
    ],

    passwordRules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 6 || "Min 6 characters",
    },

    fullnameRules: [(v) => !!v || "Full name is required"],

    CardNumberRules: [
      (v) => !!v || "Card number is required",
      //v => /^(5[1-5]{1}[0-9]{2}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{4})|(4{1}[0-9]{3}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{1}|(4{1}[0-9]{3}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{4})|(3[4|7]{1}[0-9]{2}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{3})|(3[0|6|8]{1}[0-9]{2}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{2})|(6[0-9]{3}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{4}))$/.test(v)
      (v) =>
        /^(5[1-5]{1}[0-9]{2}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{4})|(4{1}[0-9]{3}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{1}|(4{1}[0-9]{3}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{4}))$/.test(
          v
        ),
    ],

    validationCard: {
      required: (value) => !!value || "Card number is required",
      card_format: (v) =>
        /^(5[1-5]{1}[0-9]{2}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{4})|(4{1}[0-9]{3}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{1}|(4{1}[0-9]{3}[\s]?[0-9]{4}[\s]?[0-9]{4}[\s]?[0-9]{4}))$/.test(
          v
        ),
    },

    mmyyRule: [
      (v) => !!v || "MM/YY is required",
      (v) =>
        /^(0[1-9]{1}\/[0-9]{2})|(1[0|1|2]{1}\/[0-9]{2})$/.test(v) ||
        "Invalid format",
    ],

    cvc_cvvRules: [
      (v) => !!v || "CVV/CVC is required",
      (v) => /^[0-9]{3,4}$/.test(v) || "CVV/CVC must be at least 3 digits long",
    ],

    forgot_password_mobile: "",
    forgot_password_otp: "",
    saved_card_section: false,
    new_password_modal: false,
    new_password: "",
    confirmed_new_password: "",
    resigtration_otp: false,
    resigter_otp: "",

    user_entered_card_name: "",
    isSelectedCard: false,
    otp_send_text_msg: "",

    resigter_otp_text: "",
    resent_otp_text: "Resend OTP",
    display_min: 0,
    display_sec: 0,
    dispaly_time_otp: true,
    display_resend_otp_text: false,
    active_account_otp_input_text: "",

    /*Tabs visibility Dynamic */
    isCard: false,
    isMbanking: false,
    isIBanking: false,

    /*Dynamic Payment Gateways*/
    cards_gateways: "",
    mfs_gateways: "",
    ibanking_gateways: "",

    dwidth: "",

    show_terms_conditions: false,
    toc_dialog: false,
    display_card_number: "",
    store_id: 0,
    invoiceno: "",

    AgreementPopupDialog: false,
    agreementStatus: 2,

    //token validity
    isValidToken: true,

    // Payment session countdown (JWT exp / JWT_TTL)
    showSessionTimer: false,
    sessionUrgent: false,
    session_display_time: "00:00",
    sessionTimerInterval: null,

    // tdr
    is_add_commission: 0,
    normal_user: 1,

    additional_fees_amt: 0,
    payable_amt: 0,

    mfs_gateway_id_for_tdr: 0,
    gateway_type_id_tdr: 0,
    card_name_tdr: "",
    tdr_visibility: 0,
    tdr_visibility_pay_now_btn: 0,
    tdrAdditionalFeePopUp: false,

    mfs_selected_gateway_iddd: 0,
    cards_selected_gateway_iddd: 0,
    ibanking_selected_gateway_iddd: 0,

    //saved card lsit
    saved_card_list: false,

    cvv_pin: {
      one: "",
      saved_card_name: "",
      saved_card_cof_id: "",
      card_mask_pan: "",
    },
    selectedCvvIndex: null,
    cardList: "",
    card_name: "",
    card_number: "",

    cvvRules: [
      (v) => !!v || "CVV/CVC is required",
      (v) => /^[0-9]{3,4}$/.test(v) || "CVV/CVC must be at least 3 digits long",
    ],

    default_card_image: require("./assets/logos/master.png"),
    masterCard: require("./assets/logos/master.png"),
    visaCard: require("./assets/logos/visa.png"),
    amex: require("./assets/logos/amex.png"),
    unionPay: require("./assets/logos/unionpay.png"),
    dinersclub: require("./assets/logos/diners_club.png"),

    deleteCardConfirmationDialog: false,
    deleteConfirmationCard: false,
    isShowStaticPart: false,

    reset_password_mobile: "",

    isSavedCardSwitch: false,
    delete_card_id: "",
    delete_card_ui_id: "",

    loginBool: 0,
    is_card_on_file_active: 0,

    //Phone Number Validation
    translations: {
      countrySelectorLabel: "Country Code",
      countrySelectorError: "Choose a country",
      phoneNumberLabel: "Mobile Number",
      example: "Example",
    },
    resultsMobile: {},

    cof_pay_now_btn_label: "Pay Now",
    saved_card_paynow_label: "Pay Now",

    // new changes
    showCreateAccountForm: false,
    showCOFRegisterOTPForm: false,
    cof_user_reg_mobile: "",
    cof_register_otp_confirm: "",
    cof_pin_number: "",
    cof_auto_login_country_code: "",

    COFLoginPasswordRules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 6 || "Min 6 characters",
    },

    cof_signup: {
      mobile_number: "",
      password: "",
      fullname: "",
      email_address: "",
      pin: "",
      pin_confirm: "",
    },

    cof_login_pin: "",
    cof_login_mobile_number: "",

    cof_reg_otp_confirm: {
      one: "",
      two: "",
      three: "",
      four: "",
      five: "",
      six: "",
    },

    is_cof_form_enable: true,
    is_cof_form_enable_terms: true,
    is_cof_form_enable_btn: true,
    is_cof_form_enable_btn2: false,
    is_mask_card_enable: false,
    mask_card_number: "",
    mask_card_icon: "",
    isCheckLoginEnable: true,
    customer_trxn_mobile_number: "",

    isCOFLoginFormEnable: false,

    logout_tab_decision: "",

    SignUpPasswordRules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 6 || "Min 6 characters",
    },
    selected_other_card_list: "",
    paymentToHeight: "70",
    leftBorderHeight: "40",
    AccountActiveDeactiveDiv: false,
    cof_active_account_mobile: "",
    cof_active_account_otp: "",
    total_assigned_tabs: 0,
    merchantEMIBankList: [],
    currencyCode: 'USD',
    amountBDT: 120,
    currencyRatePopUp: false, // This should be a boolean, not a function
  }),

  created() {
    /*
     *The created hook can be used to run code after an instance is created.
     *In this hook we include the function which need before mounted.
     */
    //this.fetchEMIBanks(this.$route.query.order_id);
  },

  mounted() {
    this.sp_orderid = this.$route.query.order_id;
    this.sp_token = this.$route.query.token;

    if (typeof this.sp_token === "undefined") {
      this.isMainDiv = false;
      this.isUnauthorized = true;
      this.isMaintenanceMode = false;
      this.is_bisc_display = false;
    } else {
      const options = {
        method: "POST",
        url: this.base_url + "check-token",
        headers: {
          Authorization: "Bearer " + this.sp_token,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.sp_code == "200") {
            var decoded_token = jwt_decode(this.sp_token);
            var s_id = decoded_token.sub;

            if (s_id == 530) {
              this.isMainDiv = false;
              this.is_bisc_display = true;
              this.isUnauthorized = false;
              this.isMaintenanceMode = false;
            } else {
              this.isMainDiv = true;
              this.isUnauthorized = false;
              this.isMaintenanceMode = false;
              this.is_bisc_display = false;
              this.check_card_holder_login();
              this.fetchStoreEMISettings(this.sp_orderid);
              this.startSessionTimer(decoded_token, response.data.server_time);
            }
          } else if (response.data.sp_code == "503") {
            this.isMainDiv = false;
            this.isUnauthorized = false;
            this.is_bisc_display = false;
            this.isMaintenanceMode = true;
            setTimeout(this.CancelURL, 500);
          } else if (response.data.sp_code == "1064") {
            this.isMainDiv = false;
            this.isUnauthorized = true;
            this.isMaintenanceMode = false;
            this.is_bisc_display = false;
            setTimeout(this.CancelURL, 500);
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.isMainDiv = false;
            this.isUnauthorized = true;
            this.isMaintenanceMode = false;
            this.is_bisc_display = false;
          }
        });
    }

    setTimeout(this.generate_invoice, 600);
  },

  beforeDestroy() {
    this.clearSessionTimer();
  },

  computed: {
    _seconds: () => 1000,
    _mintues() {
      return this._seconds * 60;
    },
    _hours() {
      return this._mintues * 60;
    },

    MobileNumberOutput() {
      return Object.keys(this.resultsMobile);
    },
    filteredCards() {
      return this.cards_gateways.filter(
        (cards) => !this.hiddenSlugs.includes(cards.slug)
      );
    },
  },

  watch: {
    "editedItem.mm_yy": function(val) {
      let number_length = val.length;
      let firstPart;
      if (number_length == 2) {
        firstPart = val + "/";
        this.editedItem.mm_yy = firstPart;
      }
    },

    "editedItem.card_number": function(val) {
      var inputlen = val.length;
      if (inputlen == 0 || inputlen == 1) {
        this.visaDeactive = false;
        this.visaActive = true;
        this.masterCardDeactive = false;
        this.masterCardActive = true;
        this.amexDeactive = false;
        this.amexActive = true;
        this.unionpayDeactive = false;
        this.unionpayActive = true;
        this.dinersDeactive = false;
        this.dinersActive = true;

        this.isSelectedCard = false;
      }

      // if(inputlen<7 && this.is_emi_active == 1){
      //   this.colWidth = 12;
      //   this.is_emi_visible = false;
      // }

      if (inputlen == 2) {
        this.select_card_icon(val);
      }

      // if(inputlen == 7 && this.is_emi_active == 1){
      //   var bin_number_with_space = this.editedItem.card_number;
      //   var bin_number = Number(bin_number_with_space.replace(/\s/g, ''));
      //   this.CallEmiApi(bin_number);
      // }

      // if(inputlen > 11 && this.is_emi_active == 1){
      //   var bin_number_with_space2 = this.editedItem.card_number;
      //   var full_card_number = bin_number_with_space2.replace(/\s/g, '');
      //   var bin_number2 = Number(full_card_number.slice(0, 6));
      //   this.CallEmiApi(bin_number2);
      // }

      if (inputlen > 11) {
        this.select_card_icon(val);
      }
    },

    "signup_items.email_address": function(val) {
      var format = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var validate_email = val.match(format);
      var fetch_id = document.getElementById("email_style");
      if (!validate_email) {
        fetch_id.style.color = "#ff5252";
      } else {
        fetch_id.style.color = "rgba(0, 0, 0, 0.87)";
      }
    },

    "cof_reg_otp_confirm.one": function(val) {
      var otp_length = val.length;
      if (otp_length == 1) {
        document.getElementById("cof_two").focus();
      }
    },

    "cof_reg_otp_confirm.two": function(val) {
      var otp_length2 = val.length;
      if (otp_length2 == 1) {
        document.getElementById("cof_three").focus();
      }
    },

    "cof_reg_otp_confirm.three": function(val) {
      var otp_length3 = val.length;
      if (otp_length3 == 1) {
        document.getElementById("cof_four").focus();
      }
    },

    "cof_reg_otp_confirm.four": function(val) {
      var otp_length4 = val.length;
      if (otp_length4 == 1) {
        document.getElementById("cof_five").focus();
      }
    },

    "cof_reg_otp_confirm.five": function(val) {
      var otp_length5 = val.length;
      if (otp_length5 == 1) {
        document.getElementById("cof_six").focus();
      }
    },

    cof_login_mobile_number: function(val) {
      if (val !== null) {
        var mobile_number_without_hypen = val.replace(/-/g, "");
        var first_char = mobile_number_without_hypen.slice(0, 1);

        if (first_char == "0" && mobile_number_without_hypen.length == 11) {
          this.CheckMobileExistsOrNot();
        }

        if (first_char != "0" && mobile_number_without_hypen.length == 10) {
          this.CheckMobileExistsOrNot();
        }
      }
    },
  },

};
